import { httpGet } from '../../../modules/api/axios_api';
import Constants from '../../../constants/constants';
import { TournamentBoundary } from './types';

/**
 * Gets active tournaments for Tournament Service
 *
 * @method getActiveTournament
 * @memberof Tournament
 * @returns {Promise<TournamentBoundary>}
 */
export const getActiveTournament = async (): Promise<TournamentBoundary> => {
  const url = `${Constants.BACKEND_URL}/get-active-tournament`;
  return httpGet(url, {})
    .then((response) => {
      if (response?.status === 200 && response?.data.success) {
        return { ...response.data.tournament, active: response.data.active };
      }
      return null;
    })
    .catch((error) => {
      throw new Error(`Error happened with get active tournaments: ${error}`);
    });
};
